import StickyHeader from './directives/StickyHeaderDirective';
import PageDrawerSlideoutDirective from './directives/PageDrawerSlideoutDirective';
import MobileHeader from './mobileheader/MobileHeader';

export default angular.module('edge.platform.widgets.pagestructure', [])
    .directive('gwPlStickyHeader', StickyHeader)
    .directive('gwPlPageDrawerSlideout', PageDrawerSlideoutDirective)
    .directive('gwPlMobileHeader', MobileHeader);